<template>
    <section>
        <div id="intro" @click="$router.push({name: 'main-menu'})">
        </div>
    </section>
</template>

<script>

export default {
  name: 'intro',
  created() {
    document.addEventListener('keyup', () => {
      if (this.$route.name === 'intro') {
        this.$router.push({ name: 'main-menu' });
      }
    });
  },
  mounted() {
          import('./src/intro-init').then((introIinit) => {
            this.$nextTick(() => introIinit.launch());
          });
  },
};
</script>

<style scoped>
    #intro {
        display: flex;
        justify-content: center;
        height: 100vh;
    }
</style>
